// Field labels
export const FIELD_LABELS = {
    CREATED_ON: 'Created on:',
    INGREDIENT_NAME: 'Ingredient Name:',
    CAS_NUMBER: 'CAS Number:',
    RESTRICTION: 'Restriction:',
    PRIMARY_DATE: 'Primary Date:',
    SECONDARY_DATE: 'Secondary Date:',
    UL_INTERNAL_DATE: 'UL Internal Date:',
    ISSUED_BY: 'Issued By:',
    EMAIL: 'Email:',
    CATEGORY: 'Category:',
    INGREDIENT_DESCRIPTION: 'Ingredient Description:',
    ADDITIONAL_NOTES: 'Additional Notes:'
};

// Default messages
export const DEFAULT_MESSAGES = {
    NOT_AVAILABLE: 'N/A',
    NO_DATA: 'Request data not available',
    NO_DESCRIPTION: 'No description available',
    NO_ADDITIONAL_INFO: 'No Additional Info available'
};

// Restriction types
export const RESTRICTION_TYPES = {
    BANNED: 'BANNED',
    RESTRICTED: 'RESTRICTED',
    LABELING_REQUIREMENTS: 'LABELING_REQUIREMENTS',
    RESTRICTIONS_AND_LABELING: 'RESTRICTIONS_AND_LABELING',
    RESTRICTED_AND_SDS: 'RESTRICTED_AND_SDS'
};

// UI constants
export const UI_CONSTANTS = {
    LABEL_MIN_WIDTH: '90px',
    FONT_SIZES: {
        LABEL: '0.95rem',
        VALUE: '1rem',
        CHIP: '0.9rem'
    },
    MAX_DESCRIPTION_HEIGHT: 88,
    CLOSE_BUTTON_TEXT: 'Close'
};

// Icon labels
export const ICON_LABELS = {
    EXPAND_DESCRIPTION: 'Expand ingredient description',
    EXPAND_NOTES: 'Expand additional notes'
};